import React from 'react'

export default function AdminModeBanner() {
    return (
        <div className="alert alert-warning">
            <i className="fa fa-exclamation-triangle mr-2"/>
            Mode admin : les ajouts/suppressions de champs modifient le référentiel partagé par tous les groupes clients (BDREF3).
        </div>
    )
}
